module.exports = __webpack_public_path__ + "static/img/tubiao.5ee6474.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/tubiao.jpg
// module id = kqr8
// module chunks = 1